module.exports = __webpack_public_path__ + "img/service-main-1.3162fb46.png";